module.exports = __webpack_public_path__ + "static/img/15.b45a385a.png";